import { DataObject } from "@lib/titan2/dist/api/core/data/DataObject";
import { SlingoConstants } from "../model/enum/SlingoConstants";
/*
 * StakeToSpinParams.ts
 */
export class StakeToSpinParams {
    constructor(messageAcknowledged, roomName) {
        this.messageAcknowledged = messageAcknowledged;
        this.roomName = roomName;
    }
    liquify() {
        let data = new DataObject();
        data.putString(SlingoConstants.PROPERTY_ROOM_NAME, this.roomName);
        data.putBoolean(SlingoConstants.PROPERTY_MESSAGE_ACKNOWLEDGED, this.messageAcknowledged);
        return data;
    }
}
//# sourceMappingURL=StakeToSpinParams.js.map